<div class="work-content">
  <div class="iq-work-id  text-center">
    <ng-content select="[cardNumber]"></ng-content>
  </div>
  <div class="iq-work-detail text-center ">
    <ng-content select="[cardContent]"></ng-content>
  </div>
  <ng-content select="[cardLink]"></ng-content>
</div>
